import { Mesh, PlaneGeometry, Vector3, type Material } from 'three';
import type { ProfilePoint, VehicleSpec } from './types';

/** A flat panel spanning the vehicle's width along one profile segment (windscreen, back, nose). */
export function segmentQuad(spec: VehicleSpec, a: ProfilePoint, b: ProfilePoint, material: Material, widthScale = 0.94): Mesh {
  const [u1, v1] = a;
  const [u2, v2] = b;
  const length = Math.hypot(u2 - u1, v2 - v1);
  const mesh = new Mesh(new PlaneGeometry(spec.width * widthScale, length), material);
  const du = u2 - u1;
  const dv = v2 - v1;
  // Profile runs clockwise, so (-dv, du) points out of the body.
  const normal = new Vector3(0, du, dv).normalize();
  const mid = new Vector3(0, (v1 + v2) / 2, spec.length / 2 - (u1 + u2) / 2).addScaledVector(normal, 0.05);
  mesh.position.copy(mid);
  mesh.lookAt(mid.clone().add(normal));
  return mesh;
}

export function profilePoint(spec: VehicleSpec, index: number): ProfilePoint {
  const point = spec.profile[index];
  if (!point) throw new Error(`${spec.id} has no profile point ${index}`);
  return point;
}
